import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ToastProvider } from "./contexts/ToastContext";
import { LoaderProvider } from "./contexts/LoaderContext";
import Login from "./pages/login/Login";
import ClinicDetails from "./pages/tmrw-admin/ClinicDetails";
import Grading from "./pages/tmrw-admin/Grading";
import NotFound from "./pages/NotFound";
import "./App.css";

function App() {
  return (
    <>
      <AuthProvider>
        <ToastProvider>
          <LoaderProvider>
            <Routes>
              <Route index element={<Login />} />
              <Route
                path="tmrw-admin/clinic-details"
                element={<ClinicDetails />}
              />
              <Route path="tmrw-admin/gradings" element={<Grading />} />
              <Route path="/*" element={<NotFound />} />
            </Routes>
          </LoaderProvider>
        </ToastProvider>
      </AuthProvider>
    </>
  );
}

export default App;
